/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class TimeTrackerConfigurationModel {
        public processConfig: Wars.Domain.Model.ProcessConfiguration;
        public timeTrackerContainers: Wars.Domain.Model.Workflow.TimeTrackerContainer[];
        public timeTrackers: Wars.Domain.Model.Workflow.TimeTracker[];
        public systemTimeTracker: Wars.Domain.Model.Workflow.TimeTracker;
        public systemLevelTimeTrackers: Wars.Domain.Model.Workflow.TimeTracker[];
        public selectedTimeTrackerContainer: Wars.Domain.Model.Workflow.TimeTrackerContainer;
        public selectedTimeTracker: Wars.Domain.Model.Workflow.TimeTracker;
        public holidaySets: Wars.Domain.Model.HolidaySet[];
        public timeZones: Wars.Domain.Model.Dtos.TimeZoneDto[];
        public isEditing: boolean;
        public displayTimeZone: boolean;
        public selectedTimePeriod: Wars.Domain.Model.Workflow.TimePeriod;
        public isEditingTimePeriod: boolean;
        public selectedStatusGroup: Wars.Domain.Model.Statuses.StatusCodeGroup;
        public systemLevel: Wars.Domain.Model.SystemLevel;
        public clockStatuses: any;
        public timeTrackingInitialized: boolean;
        public type: string;
        public addingSystemLevelTimeTracker: boolean;

        constructor(
            private processConfigurationId: string,
            private $timeout: angular.ITimeoutService,
            private timeTrackerService: services.TimeTrackerService,
            private processConfigurationService: services.ProcessConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private statusAndStateService: services.StatusAndStateService,
            private holidaySetService: services.HolidaySetService,
            private timeZoneService: services.TimeZoneService,
            private deleteService: services.DeleteService)
        {
            this.isEditing = false;
            this.timeTrackingInitialized = false;
            this.clockStatuses = {};

            this.holidaySetService.getHolidaySets().then(h => {
                this.holidaySets = h;
            });

            if (this.processConfigurationId) {
                this.timeTrackerService.getTimeTrackerContainersByProcess(this.processConfigurationId).then(timeTrackerContainers => {
                    this.timeTrackerContainers = timeTrackerContainers;
                });
                this.processConfigurationService
                    .loadProcessConfigurationStatusGroup(this.processConfigurationId)
                    .then((processConfiguration) => {
                        this.processConfig = processConfiguration;
                        this.selectedStatusGroup = processConfiguration.myStatusCodeGroup;
                    });
                this.systemLevelService.getSystemLevelTimeTrackers().then(
                    (systemLevel) => {
                        this.systemLevelTimeTrackers = systemLevel.myTimeTrackers;
                    });
                
            } else {
                this.systemLevelService.getSystemLevelTimeTrackers().then(
                    (systemLevel) => {
                        this.systemLevel = systemLevel;
                        this.timeTrackers = systemLevel.myTimeTrackers;
                    });
            }
            

            this.timeZoneService.getValidServerTimeZones()
                .then(timeZones => {
                    this.timeZones = timeZones;
                });
        }

        private loadStatusCodeGroup(id: string, callback?: () => void): void {
            this.statusAndStateService.getStatusCodeGroup(id).then((statusCodeGroup) => {
                this.selectedStatusGroup = statusCodeGroup;
                if (callback) callback();
            });
        }

        public addNewTimeTracker() {

            this.isEditing = true;
            this.type = "actual";

            if (!this.timeTrackers) {
                this.timeTrackers = [];
            }

            if (this.processConfigurationId) {
                this.selectedTimeTrackerContainer = this.timeTrackerService.createTimeTrackerContainer(this.processConfigurationId);

                this.selectedTimeTracker = this.timeTrackerService.createTimeTracker();
                this.selectedTimeTracker.myStatusCodeGroup = this.processConfig.myStatusCodeGroup;
                this.selectedTimeTracker.statusCodeGroup_id = this.processConfig.myStatusCodeGroup.id;

                this.selectedTimeTrackerContainer.myTimeTracker = this.selectedTimeTracker;
                this.timeTrackerContainers.push(this.selectedTimeTrackerContainer);
                this.timeTrackingInitialized = true;
            } else {
                this.selectedTimeTracker = this.timeTrackerService.createTimeTracker();
                this.selectedTimeTracker.myStatusCodeGroup = this.systemLevel.statusCodeGroup;
                this.selectedTimeTracker.statusCodeGroup_id = this.systemLevel.statusCodeGroup.id;

                this.selectedTimeTracker.systemLevel_id = this.systemLevel.id;
                this.selectedTimeTracker.mySystemLevel = this.systemLevel;

                this.timeTrackers.push(this.selectedTimeTracker);
                this.timeTrackingInitialized = true;
            }
            
            this.shouldDisplayTimeZone();
            this.saveChanges();
        }

        public addExistingSystemTimeTracker() {
            this.isEditing = false;
            this.addingSystemLevelTimeTracker = true;
        }

        public addSystemLevelTimeTracker() {
            this.selectedTimeTrackerContainer = this.timeTrackerService.createTimeTrackerContainer(this.processConfigurationId);
            this.selectedTimeTrackerContainer.myTimeTracker = this.systemTimeTracker;
            this.selectedTimeTracker = this.selectedTimeTrackerContainer.myTimeTracker;
            this.timeTrackerContainers.push(this.selectedTimeTrackerContainer);
            this.addingSystemLevelTimeTracker = false;
            this.type = "reference";
            this.saveChanges();
        }

        public clockStateChanged(stateCodeId: string):void {
            var clockStatus = this.clockStatuses[stateCodeId];
            if (!clockStatus) {
                var clockStateToRemove = Enumerable.from(this.selectedTimeTracker.myClockStates).singleOrDefault(i => i.stateCode_id === stateCodeId);
                if (clockStateToRemove) clockStateToRemove.entityAspect.setDeleted();
            } else {
                var clockStateToUpdate = Enumerable.from(this.selectedTimeTracker.myClockStates).singleOrDefault(i => i.stateCode_id === stateCodeId);
                if (clockStateToUpdate) {
                    clockStateToUpdate.clockStatus = clockStatus;
                } else {
                    var clockState = this.timeTrackerService.createClockState();
                    clockState.myTimeTracker = this.selectedTimeTracker;
                    clockState.timeTracker_id = this.selectedTimeTracker.id;
                    clockState.clockStatus = clockStatus;
                    clockState.stateCode_id = stateCodeId;
                    this.selectedTimeTracker.myClockStates.push(clockState);
                }
            }
            this.saveChanges();
        }

        public deleteExistingSystemTimeTracker() {
            alert("In-Work");
        }

        private initializeClockStates(): void {
            for (var i = 0; i < this.selectedTimeTracker.myClockStates.length; i++) {
                var clockState = this.selectedTimeTracker.myClockStates[i];
                this.clockStatuses[clockState.stateCode_id] = clockState.clockStatus;
            }
            this.$timeout(() => { this.timeTrackingInitialized = true;});
        }

        public addTimePeriod() {
            this.selectedTimePeriod = this.timeTrackerService.createTimePeriod(this.selectedTimeTracker);
            this.selectedTimePeriod.value = 0;
            if (!this.selectedTimeTracker.myTimePeriods) {
                this.selectedTimeTracker.myTimePeriods = [];
            }

            this.selectedTimeTracker.myTimePeriods.push(this.selectedTimePeriod);
            this.isEditingTimePeriod = true;
        }

        public changeTimeType() {
            if (this.selectedTimeTracker.timeType === Wars.Domain.Model.Workflow.TimeType.Days) {
                this.displayTimeZone = true;
            } else {
                this.selectedTimeTracker.timeZoneId = null;
                this.displayTimeZone = false;
            }
            this.saveChanges();
        }

        public saveChanges() {
            this.timeTrackerService.saveAllChanges();
        }

        public selectTimeTrackerContainer(timeTrackerContainer: Wars.Domain.Model.Workflow.TimeTrackerContainer) {
            this.isEditingTimePeriod = false;
            this.selectedTimePeriod = null;
            this.selectedStatusGroup = null;
            this.selectedTimeTrackerContainer = timeTrackerContainer;
            this.selectedTimeTracker = timeTrackerContainer.myTimeTracker;
            this.loadStatusCodeGroup(timeTrackerContainer.myTimeTracker.statusCodeGroup_id, () => this.initializeClockStates());
            this.type = this.selectedTimeTracker.systemLevel_id ? "reference" : "actual";
            this.isEditing = true;
        }

        public deleteTimeTrackerContainer(timeTrackerContainer: Wars.Domain.Model.Workflow.TimeTrackerContainer) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "TimeTrackerContainer",
                timeTrackerContainer.id,
                "Time Tracker",
                () => {
                    this.timeTrackerContainers.remove(timeTrackerContainer);
                    this.selectedTimeTrackerContainer = undefined;
                    this.selectedTimeTracker = undefined;
                    this.isEditing = false;
                });
        }

        public selectTimeTracker(timeTracker: Wars.Domain.Model.Workflow.TimeTracker) {
            this.selectedTimeTrackerContainer = undefined;
            this.selectedTimeTracker = timeTracker;
            this.loadStatusCodeGroup(timeTracker.statusCodeGroup_id, () => this.initializeClockStates());
            this.type = "actual";
            this.isEditing = true;
        }

        public deleteTimeTracker(timeTracker: Wars.Domain.Model.Workflow.TimeTracker) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "TimeTracker",
                timeTracker.id,
                "Time Tracker",
                () => {
                    this.timeTrackers.remove(timeTracker);
                    this.selectedTimeTrackerContainer = undefined;
                    this.selectedTimeTracker = undefined;
                    this.isEditing = false;
                });
        }

        public editTimePeriod(timePeriod: Wars.Domain.Model.Workflow.TimePeriod) {
            this.isEditingTimePeriod = true;
            this.selectedTimePeriod = timePeriod;
            this.shouldDisplayTimeZone();
        }

        public deleteTimePeriod(timePeriod: Wars.Domain.Model.Workflow.TimePeriod) {
            this.isEditingTimePeriod = false;
            timePeriod.entityAspect.setDeleted();
            this.saveChanges();
            this.selectedTimeTracker.myTimePeriods.remove(timePeriod);
            this.selectedTimePeriod = undefined;
        }

        private shouldDisplayTimeZone() {
            if (this.selectedTimeTracker.timeType === Wars.Domain.Model.Workflow.TimeType.Days) {
                this.displayTimeZone = true;
            } else {
                this.displayTimeZone = false;
            }
        }
    }
}